module.exports = __webpack_public_path__ + "img/logo-Inbox.76b772c5.png";